'use strict'

module.exports = {
  properties: {},
  events: {}
}



// WEBPACK FOOTER //
// ./helpers/emptyConnectionConfig.js